<template>
  <div class="backyanse">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>
    <el-row>
      <el-col :span="24">
        <el-container class="conta auto">
          <el-image class="img" :src="$t('menu.rubber_img')" alt=""></el-image>
        </el-container>
      </el-col>
    </el-row>

    <div class="content">
      <el-row>
        <el-col :span="7">
          <Content>
            <template #MingChen>
              <div>{{ $t("menu.business") }}</div>
            </template>
            <template #ContentEr>
              <div class="inlineer">
                <li><router-link to="/RubberMaterial">
                    <div>{{ $t("menu.Rubber") }}</div>
                  </router-link></li>
              </div>
            </template>
            <template #ContentSan>
              <div class="inlineer">
                <li><router-link to="/PlasticMaterials">
                    <div>{{ $t("menu.PlasticMaterials") }}</div>
                  </router-link></li>
              </div>

            </template>
            <!-- o型圈检测 -->
            <template #ContentSi>
              <div class="inlineer">
                <li><router-link to="/Oring">
                    <div class="rubber">{{ $t("menu.OXinQuan") }}</div>
                  </router-link></li>
              </div>
            </template>

            <!-- 电工电子产品检测 -->
            <!-- <template #ContentWu>
              <div class="inlineer">
                <li><router-link to="/ElectronicElectrician">
                    <div>{{ $t("menu.DianziDianGong") }}</div>
                  </router-link></li>
              </div>
            </template> -->
          </Content>
        </el-col>

        <el-col :span="17">
          <router-view></router-view>
        </el-col>
      </el-row>
    </div>


    <MyFooter> </MyFooter>
  </div>
</template>

<script>

export default {
  name: "Oring",
  data() {
    return {
      number: "2-3",
      numeryy: "1",
      // 塑料
      SelectList: [],
      // 橡胶
      RubberList: [],
      OXinQuan: [],
      DianziDianGong: [],
      title: "",
    };
  },
  created: function () {
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }
    this.getSelect()
  },
  methods: {
    async getSelect() {
      const { data: res } = await this.$http.get("/Business/GetCatalogue", {
        params: { category: "plastic", languageType: this.title },
      });

      if (res.code !== 200) return console.log("数据请求失败! ");
      // 塑料
      this.SelectList = res.data;
      console.log(this.SelectList)

      //橡胶
      const { data: resER } = await this.$http.get("/Business/GetCatalogue", {
        params: { category: "rubber", languageType: this.title },
      });

      this.RubberList = resER.data;
      // o型圈
      const { data: ressan } = await this.$http.get("/Business/GetCatalogue", {
        params: { category: "o-ring", languageType: this.title },
      });

      if (ressan.code !== 200) return console.log("数据请求失败! ");

      this.OXinQuan = ressan.data;
      console.log(this.OXinQuan)

      // 电子电工
      // const { data: ressi } = await this.$http.get("/Business/GetCatalogue", {
      //   params: { category: "electronics", languageType: this.title },
      // });

      if (ressi.code !== 200) return console.log("数据请求失败! ");
      this.DianziDianGong = ressi.data;
    },


  },
};


</script>


<style lang="less" scoped>
.rubber {
  color: #1d2088;
  font-weight: bold
}

// /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{
//       height: 100%;
//     line-height: 100%;
// }

//  /deep/ .el-submenu__title{
//     white-space: pre-wrap;
//     height: 100%;
//     line-height: 100%;
//     padding:20px;
// }



// /deep/ .el-menu {
//   font-size: 16px;

//     .el-menu-item {
//           font-size: 14px;
//           white-space: pre-wrap;
//           // -webkit-box-orient: vertical;
//           // word-break: break-all;
//           // -webkit-line-clamp: 2;
//           // padding: 20px;
//            height: 100%;
//     padding: 20px;
//     line-height: 100%;

//     }
// }
// /deep/ .el-submenu.is-opened .el-submenu__title:nth-child(2){

//   color: #1D2088;

// }
.rubber {
  color: #1d2088;
  font-weight: bold
}

.el-submenu {
  margin-left: 0px;
}

.inlineer {
  height: 64px;
}

.shisi {
  font-size: 14px;
  background: #ffffff;
  padding: 10px;
  padding-left: 20px;
}

.White {
  position: relative;
  top: 69px;
  height: 60px;
  width: 280px;
  background: #999999;
  // padding-left: 0px;
}

.conta {
  margin-top: 161px;
}

.img {
  width: 1920px;
  height: 315px;
}

.Xjiao {
  color: #1d2088;
  font-size: 20px;
}

.divider {
  background-color: #eeeeee;
}

.fff {
  background: #ffffff;
  padding: 0px 20px;
  margin-bottom: 20px;
}

.SanJiao {
  position: relative;
  bottom: 40px;
  left: 228px;
}

span {
  color: #666666;
}

a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
  color: black;
}

a:-webkit-any-link:focus,
a:-webkit-any-link:hover {
  color: #1D2088;
  font-weight: bold;
}

/deep/ .router-link-active {
  font-weight: normal;
}
</style>